<script setup lang="ts">
defineProps<{
  loading: boolean;
}>();
</script>

<template>
  <div v-if="loading" class="pointer-events-none w-full animate-pulse rounded-sm bg-md">
    <div class="size-full opacity-0">
      <slot />
    </div>
  </div>
  <slot v-else />
</template>
